import React, { useState } from "react";
import axios from "axios";
import InputField from "./InputField";
import TextArea from "./TextArea";
import Button from "./Button";
import ReCAPTCHA from "react-google-recaptcha";

function Form() {
  const [captchaValue, setCaptchaValue] = useState(null);
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  const SITE_KEY = process.env.REACT_APP_SITE_KEY;
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  const handleCaptchaChange = (value) => {
    setCaptchaValue(value);
  };

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage(null);
    setError(null);

    if (!formData.name.trim()) {
      setError("Please enter your name.");
      return;
    }
    if (!formData.email.trim()) {
      setError("Please enter your email address.");
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      setError("Please enter a valid email address.");
      return;
    }
    if (!formData.subject.trim()) {
      setError("Please enter a subject.");
      return;
    }
    if (!formData.message.trim()) {
      setError("Please enter your message.");
      return;
    }
    if (!captchaValue) {
      setError("Please verify that you are not a robot.");
      return;
    }

    try {
      const response = await axios.post(`${BACKEND_URL}/auth/contact/`, {
        ...formData,
        captcha: captchaValue,
      });
      
      setMessage(response.data.message);
      setFormData({ name: "", email: "", subject: "", message: "" });
      setCaptchaValue(null);
    } catch (err) {
      setError(
        err.response?.data?.error ||
          "An error occurred while submitting the form. Please try again."
      );
    }
  };

  return (
    <section id="contact-form" data-aos="fade-right">
      <h1 className="contact-h1 text-3xl font-bold mb-3">
        Drop us a message for any query
      </h1>
      <div className="mycontact-form max-w-2xl mx-auto p-6 bg-white shadow-md rounded-lg">
        {message && (
            <p className="success-message">{message}</p>
        )}
        {error && (
         
            <p className="error-message">{error}</p>
      
        )}
        <div className="row flex flex-wrap -mx-2">
          <div className="col-12 col-sm-12 col-lg-6 col-md-6 px-2">
            <InputField
              placeholder="Your name"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
            />
          </div>
          <div className="col-12 col-sm-12 col-lg-6 col-md-6 px-2">
            <InputField
              type="email"
              placeholder="Your email address"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
            />
          </div>
        </div>
        <div className="row contact-row flex -mx-2">
          <div className="col-12 col-sm-12 col-lg-12 col-md-12 px-2">
            <InputField
              placeholder="Subject"
              name="subject"
              value={formData.subject}
              onChange={handleInputChange}
            />
          </div>
        </div>
        <TextArea
          placeholder="Type your message here.."
          name="message"
          value={formData.message}
          onChange={handleInputChange}
        />
        <div className="my-3">
          <ReCAPTCHA
            sitekey={SITE_KEY}
            onChange={handleCaptchaChange}
          />
        </div>
        <Button type="button" content="Submit" onClick={handleSubmit} />
      </div>
    </section>
  );
}

export default Form;